'use client';

import React, { memo, useCallback, useState } from 'react';
import useZStore, { getExamplesToLearn } from '@/utils/useZStore';
import QuizzAnswersList from './QuizzAnswersList';
import { AnswerLogEntry } from './QuizzQuestion';
import TopQuizzArea from './TopQuizzArea';
import QuizWelcome from './QuizWelcome';

const getRandomQuizType = () => {
  const quizTypes = ['command', 'flag'];
  return quizTypes[Math.floor(Math.random() * quizTypes.length)];
};

const Quizz = () => {
  const unlearnedExamples = useZStore(getExamplesToLearn());
  const [answeredExamples, setAnsweredExamples] = useState<AnswerLogEntry[]>(
    [],
  );
  const [quizType, setQuizType] = useState(getRandomQuizType());
  const [welcomeDismissed, setWelcomeDismissed] = useState(false);

  const handleAnswer = useCallback(
    (isCorrect: boolean, exampleId: string, answerGiven: string) => {
      const newAnsweredExamples = [
        ...answeredExamples,
        { exampleId, correct: isCorrect, user_answer: answerGiven },
      ];
      setAnsweredExamples(newAnsweredExamples);
      setQuizType(getRandomQuizType());
    },
    [answeredExamples],
  );

  const handleReset = useCallback(() => {
    setAnsweredExamples([]);
  }, []);

  if (!welcomeDismissed) {
    return <QuizWelcome onClick={() => setWelcomeDismissed(true)} />;
  }

  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center px-4 sm:px-0">
      <TopQuizzArea
        answeredExamples={answeredExamples}
        unlearnedExamples={unlearnedExamples}
        onAnswer={handleAnswer}
        quizType={quizType}
        onStartNewQuizz={handleReset}
      />
      <QuizzAnswersList answers={answeredExamples} />
    </div>
  );
};

export default memo(Quizz);
